import { IRequestId } from './../domain/id.entity';
import { Injectable } from '@angular/core';
import { ISearchResult, IApplicationLink, IApplicationRoutes } from 'ops-lib';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class CommonApiService {

  private readonly baseUrl = `${environment.commonAPI}`;
  constructor(private httpClient: HttpClient) {
  }

  Search(body: any): Observable<Array<ISearchResult>> {
      return this.httpClient.post<Array<ISearchResult>>(this.baseUrl + 'search', body);
    }

  getNavigationBarLinks(body: IRequestId): Observable<IApplicationLink[]> {
      return this.httpClient.post<IApplicationLink[]>(this.baseUrl + 'application/v2/navigation', body);
    }

  getApplicationsRoutes(): Observable<IApplicationRoutes[]> {
      return this.httpClient.get<IApplicationRoutes[]>(this.baseUrl + 'application/routes');
    }

  addRedirectToken(body: IAddRedirectToken): Observable<any> {
      return this.httpClient.post<any>(this.baseUrl + 'redirect', body);
    }

  GetKeycloakEnabled(): Observable<IKCResponse> {
      return this.httpClient.get<IKCResponse>(this.baseUrl + 'application/keycloak');
    }
}

export interface ISearchRequest {
  type: string;
  criteria: string;
  features: string;
  from?: Date;
  to?: Date;
}

interface IAddRedirectToken {
  url: string;
}

interface IKCResponse {
  enabled: boolean;
}

